export class SaleBudgetRequest{
    id:number
    month:string
    year:string
    noOfContainers:number
    salePersonId:number
    isActive: boolean;
    createdAt : Date ;
    createdUser : string;
    updatedAt : Date ;
    updatedUser : string;
    versionFlag : number;
    
    constructor(
    id:number,
    month:string,
    year:string,
    noOfContainers:number,
    salePersonId:number,
    isActive: boolean,
    createdAt : Date ,
    createdUser : string,
    updatedAt : Date ,
    updatedUser : string,
    versionFlag : number,

    ){
        this.id = id
        this.month = month
        this.year = year
        this.salePersonId = salePersonId
        this.noOfContainers = noOfContainers
         this.isActive = isActive
        this.createdAt = createdAt
        this.createdUser = createdUser
        this.updatedAt = updatedAt 
        this.updatedUser = updatedUser
        this.versionFlag = versionFlag
    }
}